import { makeStyles } from 'makeStyles';
import { TEXT_MAIN } from 'theme/colors';

const CONTAINER_WIDTH = 560;

export const useStyles = makeStyles()((theme) => ({
  participantsTable: {
    '& .MuiTableCell-root': {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
    '& .MuiTableCell-root + .MuiTableCell-root': {
      borderLeft: `1px solid rgba(224, 224, 224, 1)`,
    },
    '& .MuiTableCell-head': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      fontWeight: 900,
      borderTop: `1px solid rgba(224, 224, 224, 1)`,
      borderBottom: `2px solid rgba(224, 224, 224, 1)`,
    },
  },
  checkBoxCell: {
    width: '30px',
  },
  indexCell: {
    width: '20px',
  },
  buttonIcon: {
    height: '16px',
    marginRight: theme.spacing(1),
    stroke: theme.palette.grey['50'],
    width: 'auto',
  },
  clickable: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  removeSplitDrawParticipant: {
    color: theme.palette.primary.main,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  participantTableActionContainer: {
    minHeight: 80,
  },
  saveSeedsButton: {
    border: '1px solid #9ab3ce',
    backgroundColor: '#f4f9ff',
    color: '#35689d',
  },
  listItem: {
    cursor: 'pointer',
  },
  bodyLarge: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  noParticipants: {
    fontWeight: 'bold',
    color: '#3e424e',
  },
  tmxDialog: {},
  tmxDialogPaper: {
    width: '100%',
    maxWidth: CONTAINER_WIDTH,
    boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)',
    padding: theme.spacing(4),
  },
  selectInput: {
    padding: '16.5px 0 5px 0 ',
    width: '100%',
  },
  selectPlayerStatusContent: {
    minWidth: 120,
    width: '100%',
    margin: 0,
    padding: 0,
    '& fieldset': {
      border: 0,
      borderRadius: 0,
      borderBottom: `1px solid ${TEXT_MAIN}`,
    },
  },
}));
